import { Pipe, PipeTransform } from '@angular/core';
import { getAppendButtonsIcon } from '@common/utils';

@Pipe({
  name: 'appendButtonIcon',
  pure: true
})
export class GetAppendButtonsIconPipe implements PipeTransform {
  transform(value: string): string {
    return getAppendButtonsIcon(value);
  }
}
